var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01652 10.5946C1.90304 10.4149 1.84629 10.3251 1.81453 10.1865C1.79067 10.0824 1.79067 9.91824 1.81453 9.81415C1.84629 9.67556 1.90304 9.58571 2.01652 9.40601C2.95436 7.92103 5.74592 4.16699 10.0001 4.16699C14.2543 4.16699 17.0458 7.92103 17.9837 9.40601C18.0971 9.58571 18.1539 9.67556 18.1857 9.81415C18.2095 9.91824 18.2095 10.0824 18.1857 10.1865C18.1539 10.3251 18.0971 10.4149 17.9837 10.5946C17.0458 12.0796 14.2543 15.8337 10.0001 15.8337C5.74592 15.8337 2.95436 12.0796 2.01652 10.5946Z",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.5003C11.3808 12.5003 12.5001 11.381 12.5001 10.0003C12.5001 8.61961 11.3808 7.50033 10.0001 7.50033C8.61938 7.50033 7.50009 8.61961 7.50009 10.0003C7.50009 11.381 8.61938 12.5003 10.0001 12.5003Z",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye-black.e364ecff9505dd7d6ecab75e99f348c1.svg";
export { ForwardRef as ReactComponent };